/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ListPaddocksByOrganizationQueryResponse, ListPaddocksByOrganizationPathParams, ListPaddocksByOrganizationQueryParams, ListPaddocksByOrganization400, ListPaddocksByOrganization401, ListPaddocksByOrganization403, ListPaddocksByOrganization404, ListPaddocksByOrganization409, ListPaddocksByOrganization500 } from "../../types/paddockController/ListPaddocksByOrganization.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { listPaddocksByOrganization } from "../../client/paddockController/listPaddocksByOrganization.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const listPaddocksByOrganizationQueryKey = (organizationId: ListPaddocksByOrganizationPathParams["organizationId"] | undefined, params?: ListPaddocksByOrganizationQueryParams) => [{ url: '/api/organizations/:organizationId/paddocks', params: {organizationId:organizationId} }, ...(params ? [params] : [])] as const

export type ListPaddocksByOrganizationQueryKey = ReturnType<typeof listPaddocksByOrganizationQueryKey>

export function listPaddocksByOrganizationQueryOptions(organizationId: ListPaddocksByOrganizationPathParams["organizationId"] | undefined, params?: ListPaddocksByOrganizationQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = listPaddocksByOrganizationQueryKey(organizationId, params)
        return queryOptions<ListPaddocksByOrganizationQueryResponse, ResponseErrorConfig<ListPaddocksByOrganization400 | ListPaddocksByOrganization401 | ListPaddocksByOrganization403 | ListPaddocksByOrganization404 | ListPaddocksByOrganization409 | ListPaddocksByOrganization500>, ListPaddocksByOrganizationQueryResponse, typeof queryKey>({
         enabled: !!(organizationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return listPaddocksByOrganization(organizationId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List paddocks across the organization (optionally one farm via ?establishmentId)
 * {@link /api/organizations/:organizationId/paddocks}
 */
export function useListPaddocksByOrganization<TData = ListPaddocksByOrganizationQueryResponse, TQueryData = ListPaddocksByOrganizationQueryResponse, TQueryKey extends QueryKey = ListPaddocksByOrganizationQueryKey>(organizationId: ListPaddocksByOrganizationPathParams["organizationId"] | undefined, params?: ListPaddocksByOrganizationQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ListPaddocksByOrganizationQueryResponse, ResponseErrorConfig<ListPaddocksByOrganization400 | ListPaddocksByOrganization401 | ListPaddocksByOrganization403 | ListPaddocksByOrganization404 | ListPaddocksByOrganization409 | ListPaddocksByOrganization500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? listPaddocksByOrganizationQueryKey(organizationId, params)
         

         const query = useQuery({
          ...listPaddocksByOrganizationQueryOptions(organizationId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ListPaddocksByOrganization400 | ListPaddocksByOrganization401 | ListPaddocksByOrganization403 | ListPaddocksByOrganization404 | ListPaddocksByOrganization409 | ListPaddocksByOrganization500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}